import { Modal } from '@/components/ui/modal'
import { Button } from '@/components/ui/button'
import { PageTitle } from '@/components'

export interface LogoutConfirmationModalProps {
  showLogoutConfirmationModal: boolean
  setLogoutConfirmationModal: (show: boolean) => void
  onSuccess: () => void
  loading?: boolean
}

export const LogoutConfirmationModal = (
  props: LogoutConfirmationModalProps,
): JSX.Element => {
  const {
    showLogoutConfirmationModal,
    setLogoutConfirmationModal,
    onSuccess,
    loading,
  } = props

  return (
    <Modal
      open={showLogoutConfirmationModal}
      onOpenChange={setLogoutConfirmationModal}
      title={
        <div className="border-b border-monochrome-120 pb-4">
          <PageTitle title="Logout" />
        </div>
      }
      size="sm"
      footer={
        <div className="flex w-full items-center gap-2 justify-end mt-4 border-t border-monochrome-120 pt-4">
          <Button
            onClick={() => setLogoutConfirmationModal(false)}
            variant="secondary"
            type="button"
          >
            No
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onSuccess}
            loading={loading}
          >
            Yes
          </Button>
        </div>
      }
    >
      <div className="text-monochrome-1 text-body-medium">
        <span className="mb-2">Are you sure you want to logout?</span>
      </div>
    </Modal>
  )
}
